import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { Rootstate } from '../store';
const navigation = [
    { name: 'Overview', href: '/main' },
    { name: 'Create map', href: '/main/create'},
    { name: 'Tokens', href: '/main/tokens' },
    { name: 'Map images', href: "/main/map-images" },
    { name: 'Spectate', href: '/main/spectate' },
];

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ');
}

const Navbar = () => {
    const location = useLocation();
    const { guildId, channelId } = useSelector((state: Rootstate) => ({
        guildId: state.auth.guildId,
        channelId: state.auth.channelId,
    }), shallowEqual);

    const fileredNavigation = (!guildId || !channelId)
        ? navigation.filter(({ href }) => href !== '/main/spectate')
        : navigation;
    return (
        <nav className="bg-deep-blue">
            <div className="mx-auto max-w-7xl px-2">
                <div className="relative flex h-8 items-center justify-between">
                    <div className="flex flex-1 items-stretch justify-start">
                        <div className="block">
                            <div className="flex space-x-4 items-center h-full">
                                {fileredNavigation.map((item) => (
                                    <Link
                                        key={item.name}
                                        to={item.href}
                                        className={classNames(
                                            item.href === location.pathname
                                                ? 'bg-gray-900 text-white'
                                                : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                            'rounded-md px-2 py-1 text-sm font-medium',
                                        )}
                                        aria-current={item.href === location.pathname ? 'page' : undefined}
                                    >
                                        {item.name}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
